/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_List_Title1Inputs */

const en_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event List`)
};

const ar_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قائمة الفعاليات`)
};

const de_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventliste`)
};

const es_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de eventos`)
};

const fr_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des événements`)
};

const it_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco eventi`)
};

const ja_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント一覧`)
};

const ko_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 목록`)
};

const pt_br_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de Eventos`)
};

const ru_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список событий`)
};

const th_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการกิจกรรม`)
};

const tr_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik Listesi`)
};

const zh_cn_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动列表`)
};

const zh_tw_event_list_title1 = /** @type {(inputs: Event_List_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動列表`)
};

/**
* | output |
* | --- |
* | "Event List" |
*
* @param {Event_List_Title1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
const event_list_title1 = /** @type {((inputs?: Event_List_Title1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_List_Title1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_list_title1(inputs)
	if (locale === "ar") return ar_event_list_title1(inputs)
	if (locale === "de") return de_event_list_title1(inputs)
	if (locale === "es") return es_event_list_title1(inputs)
	if (locale === "fr") return fr_event_list_title1(inputs)
	if (locale === "it") return it_event_list_title1(inputs)
	if (locale === "ja") return ja_event_list_title1(inputs)
	if (locale === "ko") return ko_event_list_title1(inputs)
	if (locale === "pt_br") return pt_br_event_list_title1(inputs)
	if (locale === "ru") return ru_event_list_title1(inputs)
	if (locale === "th") return th_event_list_title1(inputs)
	if (locale === "tr") return tr_event_list_title1(inputs)
	if (locale === "zh_cn") return zh_cn_event_list_title1(inputs)
	return zh_tw_event_list_title1(inputs)
});
export { event_list_title1 as "Event_list_title" }